export function intersection(a, b) {
    return a.filter(x => b.includes(x))
}

export function any(a, b) {
    return intersection(a, b).length > 0
}

export function many(x) {
    const y = x ?? []

    return Array.isArray(y) ? y : [y]
}

export function take(a, n) {
    return a.map(x => x[n])
}
